import "./video.css";
import { Header } from "../../elements/header/Header";
import { useEffect, useState } from "react";
import VideoPreviewPlaceholder from "../../elements/video-preview/placeholder";
import Video from "../../elements/video-preview/video";
import { requestJSONBy } from "../../functions/api/fetcher";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function VideoPage() {
    const navigate = useNavigate();
    const [videosList, setVideosList] = useState(null);
    const [currVideo, setCurrVideo] = useState(0);

    const [searchParams] = useSearchParams();

    useEffect(() => {
        requestJSONBy('/api/v1/get_recomendations.php', (data) => {
            setVideosList(data.videos);
            // setVideosList([]);
        }, () => {
            setVideosList([]);
        })

        const videoID = searchParams.get("id");
        if (videoID !== null) {
            requestJSONBy(`/api/v1/get_video.php?id=${videoID}`, (data) => {
                setCurrVideo(data.video);
            }, () => {
                setCurrVideo(null);
            })
        } else {
            setCurrVideo(null)
        }
    }, [searchParams])
    return <>
        <Header />
        <div className="videopage">
            <div className="videopage-left">
                {currVideo !== 0 && currVideo !== null &&
                <>
                    <video key={currVideo.video} controls>
                        <source src={currVideo.video} />
                    </video>
                    <h2>{currVideo.title}</h2>
                    <h3>{currVideo.views} просмотров</h3>
                    <div className="video-actions">
                        <button>{`👎 ${currVideo.dislikes}`}</button>
                        <button>{`👍 ${currVideo.likes}`}</button>
                    </div>
                    <div className="channel-frame">
                        <img src={currVideo.channel.avatar || "/images/white/account/avatar.jpg"} alt={currVideo.channel.title} onClick={()=>navigate(`/channel?id=${currVideo.channel.id}`)} />
                        <div className="channel-text" onClick={()=>navigate(`/channel?id=${currVideo.channel.id}`)}>
                            <h3>{currVideo.channel.title}{currVideo.channel.verified? <img className="verifed-tick" alt="verified" src="/images/white/account/verified.svg" />: ""}</h3>
                            <h4>{currVideo.channel.subscribers} подписчиков</h4>
                        </div>
                        <button className="subscr-btn">Подписаться</button>
                        <button className="subscr-btn-short">+</button>
                    </div>
                </>
                }
                {currVideo === null && <div className="instead-video-placeholder"><h1>404</h1><h3>Видео не найдено.</h3></div>}
                {currVideo === 0 && <div className="instead-video-placeholder"><h3>Грузим...</h3></div>}
            </div>
            <div className="videopage-right">
                {videosList === null? [...Array(30)].map((e, i) => <VideoPreviewPlaceholder  key={i} />):""  /* Placeholder */}
                {videosList?.length > 0 && <VideosList videos={videosList} />}
            </div>
        </div>
    </>
}

function VideosList({videos}) {
    return <>
        {
            videos.map(element => {
                return <Video video={element} />
            })
        }
    </>
}